import { createFeatureSelector, createSelector } from '@ngrx/store';

import { NotificationsState } from './models/notifications-state.interface';

import { NOTIFICATIONS_FEATURE_NAME } from './notifications.actions';

export const notificationsFeatureSelector = createSelector(
  createFeatureSelector<NotificationsState>(NOTIFICATIONS_FEATURE_NAME),
  state => state,
);

export const visibleNotifications = createSelector(
  notificationsFeatureSelector,
  state => state.notifications.filter(notification => !notification.hidden),
);

export const hiddenNotifications = createSelector(
  notificationsFeatureSelector,
  state => state.notifications.filter(error => error.hidden),
);

export const visibleErrorNotifications = createSelector(
  visibleNotifications,
  notifications => notifications.filter(notification => notification.type === 'danger'),
);

export const hiddenErrorNotifications = createSelector(
  hiddenNotifications,
  notifications => notifications.filter(notification => notification.type === 'danger'),
);
